import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useLoader } from '../../../context/loaderContext';
import Loader from './loader/loader';
import { connect } from 'react-redux';
import classes from './layout.module.css';
import Header from '../../containers/header/header';
import MobileHeader from '../../containers/header/mobileHeader'
import Footer from '../../containers/footer/footer';
import { authCheckState, logout, changeLanguage, fetchUserProfile, clearError, clearMessage } from "../../../store/actions";
import Button from "../../containers/button/button";
import Book from '../../../assets/images/book-icon.png';
import Chat from '../../../assets/images/chat-icon.png';
import Close from '../../../assets/images/close-icon.png';
import Path from '../../../assets/images/path-icon.png';
import Birthday from '../../../assets/images/birthday-icon.png';
import Rain from '../../../assets/images/rain-icon.png';
import Sun from '../../../assets/images/sun-icon.png';
import Team from '../../../assets/images/team-icon.png';
import Camp from '../../../assets/images/camp-icon.png';
import LoginModal from '../../containers/loginModal/loginModal';
import CampRegistrationForm from '../../camps/campRegistrationForm/campRegistrationForm';
import TawkTo from '../../TawkTo/TawkTo';

const Layout = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isLoading, showLoader, hideLoader } = useLoader();
    const [width, setWidth] = useState(0);
    const [bookNowAndChatBoxClicked, setBookNowAndChatBoxClicked] = useState(true);
    const [showCloseIcon, setShowCloseIcon] = useState(false);
    const [showLoginForm, setShowLoginForm] = useState(false);

    const handleResize = () => setWidth(window.innerWidth);
    useEffect(() => {
        // Clear any existing messages first
        props.onClearMessage();
        props.onClearError();
        
        !localStorage.getItem('language') && props.onSetLanguage(1);
        
        props.onCheckAuth().then(() => {
            // Clear any success messages after auth state restoration
            props.onClearError();
            props.onClearMessage();
        });
        
        if (props.isAuthenticated) props.onGetProfile();
        setWidth(window.innerWidth)
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            // Also clear on unmount
            props.onClearError();
            props.onClearMessage();
        }
    }, []);
    useEffect(() => {
        if (props.isAuthenticated) props.onGetProfile();
        setShowLoginForm(false);
    }, [props.isAuthenticated]);
    // Show loader when route changes
    useEffect(() => {
        showLoader();
        const timeoutId = setTimeout(() => {
            hideLoader();
        }, 500);  // Adjust delay for loading

        return () => clearTimeout(timeoutId);
    }, [location]);
    useEffect(() => {
        if (location.state?.preserveForm) {
            props.setShowCampRegistrationForm(true); // Preserve the form if instructed
        } else {
            props.setShowCampRegistrationForm(false); // Close the form by default
        }
    }, [location.state]);  
    useEffect(() => {
        if (!location.pathname.startsWith("/camps")) {
            props.setShowCampRegistrationForm(false); // Close form when not on camp pages
        }
    }, [location.pathname]);      
    
    const getTranslatedText = (englishText) => {
        const isEnglish = parseInt(localStorage.getItem('language')) === 1;
        
        const translations = {
            'FIELD': 'ملعب',
            'BIRTHDAY': 'عيد ميلاد',
            'WINTER CAMP': 'مخيم الشتاء',
            'SUMMER CAMP': 'مخيم الصيف',
            'TEAM BUILDING': 'بناء الفريق',
            'FOOTBALL CAMP': 'مخيم كرة القدم',
            'BOOK': 'حجز',
            'CHAT': 'محادثة'
        };
        
        return isEnglish ? englishText : translations[englishText] || englishText;
    };
    
    const bookNowClickedHandler = () => {
        setShowCloseIcon(!showCloseIcon)
        if (!props.isAuthenticated) setShowLoginForm(true);
        else setShowLoginForm(false);
    }
    const bookingButtonClicked = (link, camp) => {
        if (!props.isAuthenticated) {
            setShowLoginForm(true); // Show login form if the user is not authenticated
        } else if (camp) {
            const targetPath = `/camps/${camp.toLowerCase()}-camp`; // Construct dynamic camp page path
    
            if (location.pathname !== targetPath) {
                // Navigate to the camp page if not already there
                navigate(targetPath, {
                    state: {
                        showCampRegistrationForm: true, // Ensure form stays open
                        camp: camp,
                        scrollToTop: true,
                    },
                });
            } else {
                // If already on the camp page, ensure form is visible
                props.setShowCampRegistrationForm(true);
                props.setCamp(camp);
                props.setBookNowAndChatBoxClicked(false);
                window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to the top
            }
        } else {
            // If navigating away from the current camp page (e.g., to Home)
            if (location.pathname.startsWith("/camps")) {
                // Close the form explicitly when leaving a camp page
                props.setShowCampRegistrationForm(false);
            }
            // Navigate to the desired link
            navigate(link);
            props.setBookNowAndChatBoxClicked(false);
        }
    };
    
    return (
        <div className={classes.Layout}>
            {width < 1024 ? <MobileHeader isAuthenticated={props.isAuthenticated}
                onLogout={() => props.onLogout()}
                width={width}
                menuItems={props.menuItems}
                navigate={navigate}
                userData={props.userData}
            /> :
                <Header isAuthenticated={props.isAuthenticated}
                    onLogout={() => props.onLogout()}
                    width={width}
                    menuItems={props.menuItems}
                    navigate={navigate}
                    userData={props.userData}
                />}
            {isLoading && <Loader />}
            {!props.showCampRegistrationForm && <Outlet />} {/* This is where the nested routes will be rendered */}
            <div className={[classes.BookNowAndChatBox, bookNowAndChatBoxClicked && classes.HideButton].join(" ")}
                onClick={() => setBookNowAndChatBoxClicked(!bookNowAndChatBoxClicked)}>
                <span className={classes.Arrow} />
            </div>
            {!bookNowAndChatBoxClicked ? null : <div className={[classes.Buttons, showCloseIcon && classes.WithBookButtons].join(" ")}>
                <div className={[classes.CloseIcon, showCloseIcon && classes.CloseIconWithButtons].join(" ")} 
                    onClick={() => setBookNowAndChatBoxClicked(!bookNowAndChatBoxClicked)}>
                    <span>x</span>
                </div>
                {showCloseIcon && <div className={classes.BookButtons}>
                    <Button content={getTranslatedText('FIELD')} whiteBackground icon={Path} onClick={() => bookingButtonClicked('/field-booking')} />
                    <Button content={getTranslatedText('BIRTHDAY')} whiteBackground icon={Birthday} onClick={() => bookingButtonClicked('/activities/birthdays')} />
                    <Button content={getTranslatedText('WINTER CAMP')} whiteBackground icon={Rain} onClick={() => bookingButtonClicked(null, 'Winter')} />
                    <Button content={getTranslatedText('SUMMER CAMP')} whiteBackground icon={Sun} onClick={() => bookingButtonClicked(null, 'Summer')} />
                    <Button content={getTranslatedText('TEAM BUILDING')} whiteBackground icon={Team} onClick={() => bookingButtonClicked('/activities/team-building')} />
                    <Button content={getTranslatedText('FOOTBALL CAMP')} whiteBackground icon={Camp} onClick={() => bookingButtonClicked(null, 'Football')} />
                </div>}
                <Button content={getTranslatedText('BOOK')} icon={showCloseIcon ? Close : Book} onClick={bookNowClickedHandler} />
                <Button content={getTranslatedText('CHAT')} whiteBackground icon={Chat} onClick={() => {
                    if (window.Tawk_API) {
                        window.Tawk_API.maximize();
                    }
                }} />
            </div>}
            {showLoginForm && <LoginModal setShowLoginForm={setShowLoginForm} />}
            {props.showCampRegistrationForm && <CampRegistrationForm
                    setShowCampRegistrationForm={props.setShowCampRegistrationForm} camp={props.camp} />}
            <TawkTo />
            <Footer newsLetterSections={props.pageSections.filter(section => section.section_key === "newsletter")[0]}
                socialLinks={props.socialLinks} quickLinks={props.quickLinks} contactInfo={props.contactInfo} />
        </div>
    )
}
const mapStateToProps = state => ({
    isAuthenticated: state.auth.token !== null,
    user: state.auth.user,
    userData: state.profile.userProfile,
});
const mapDispatchToProps = dispatch => {
    return {
        onCheckAuth: () => {
            return dispatch(authCheckState());
        },
        onLogout: () => {
            return dispatch(logout());
        },
        onSetLanguage: (id) => {
            dispatch(changeLanguage(id));
        },
        onGetProfile: () => {
            dispatch(fetchUserProfile());
        },
        onClearError: () => {
            dispatch(clearError());
        },
        onClearMessage: () => {
            dispatch(clearMessage());
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Layout);